import { Meet } from "./Meet";

class KhungNoiDungsEndpoint extends Meet {
    constructor() {
        super("/KhungNoiDungs");
    }
    UploadFile(key, data, config) {
        return this.UploadAuth('/Upload', { ...data, key: key }, config)
    }
    /**
     * Upload thư mục (folder) kèm khung nội dung
     * @param {string} key - UUID của khung nội dung
     * @param {File[]} files - Danh sách file trong thư mục
     * @param {string[]} relativePaths - Đường dẫn tương đối của từng file
     * @param {number[]} [positions] - Vị trí sắp xếp (optional)
     * @param {object} [config] - Config cho request
     */
    UploadFolder(key, files, relativePaths, positions, config) {
        const formData = new FormData();
        formData.append('key', key);
        files.forEach((file) => {
            formData.append('files', file);
        });
        relativePaths.forEach((path) => {
            formData.append('relativePaths', path);
        });
        if (positions && positions.length > 0) {
            positions.forEach((pos) => {
                formData.append('positions', pos);
            });
        }
        return this.UploadFormData('/UploadFolder', formData, config);
    }

    addKhungNoiDung(data) {
        return this.PostAuthen('/ThemKhungNoiDung', data)
    }
    getDataByIdPhien = (id) => this.SearchAllow(`?$expand=boSungVanDes,KhungNoiDungOrganizations($select=organizationId;$filter=isChuTri eq true)&$filter=phienHopId eq ${id}&$orderby=thuTu`);

    getDataByIdPhienNotMap = (id) => this.SearchAllow(`?$expand=boSungVanDes &$filter=phienHopId eq ${id}&$orderby=thuTu`);


    getDataByID = (id) => {
        return this.SearchAllow(`(${id})?$expand=nguoiThucHien($expand=thongTinCaNhan($select=ten,hoVaTenDem)),nhanSu($expand=thongTinCaNhan($select=ten,hoVaTenDem)),KhungNoiDungOrganizations($expand=organization($select=id,organName))&$select=id,noiDung,batDau,ketThuc,nhanSuId,fileId`)
    }
    getDataDetailByID = (id) => {
        return this.SearchAllow(`(${id})?$expand=thanhPhanThamDus,nguoiThucHien($expand=thongTinCaNhan($select=ten,hoVaTenDem)),KhungNoiDungOrganizations($expand=organization($select=id,organName)),nhanSu($expand=thongTinCaNhan($select=ten,hoVaTenDem))&$select=id,noiDung,batDau,ketThuc,trangThai,phienHopId,nhanSuId,tatDangKi,fileId`)
    }

    deleteNoiDung = (id) => {
        return this.DeleteAUTH(`(${id})`);
    }
    getAllFile = (id) => {
        return this.GetAuthen(`/GetAttachments?key=${id}`)
    }
    /**
     * Browse attachments theo cấu trúc folder/file
     * @param {string} key - UUID của khung nội dung
     * @param {string} [path] - Đường dẫn thư mục con (optional, mặc định root)
     */
    BrowseAttachments = (key, path) => {
        let url = `/BrowseAttachments?key=${key}`;
        if (path) url += `&path=${encodeURIComponent(path)}`;
        return this.GetAuthen(url);
    }

    /**
     * Đổi tên thư mục đính kèm khung nội dung
     * @param {string} key - UUID khung nội dung
     * @param {string} folderPath - Đường dẫn thư mục hiện tại
     * @param {string} newFolderPath - Đường dẫn thư mục mới
     */
    RenameFolder = (key, folderPath, newFolderPath) => {
        return this.PostAuthen('/RenameFolder', { key, folderPath, newFolderPath });
    }

    /**
     * Xóa thư mục đính kèm khung nội dung (và toàn bộ file bên trong)
     * @param {string} key - UUID khung nội dung
     * @param {string} folderPath - Đường dẫn thư mục cần xóa
     */
    DeleteFolder = (key, folderPath) => {
        return this.PostAuthen('/DeleteFolder', { key, folderPath });
    }
    updateData = (id, data, conf = null) => { return this.PatchAuthen(`(${id})`, data, conf) }

    updateOrganizations = (data) => this.PostAuthen('/AddKhungOrganization', data)

    getDataByOrderAndSession = (idPhien, thuTu) => { return this.SearchAllow(`?$filter=phienHopId eq ${idPhien} and thuTu eq ${thuTu}`) }

    getFullThanhPhanThamDu = (idNoiDung) => {
        return this.SearchAllow(`(${idNoiDung})?$expand=thanhPhanThamDus&$select=id`)
    }
    getKhachMoiThamDu = (idNoiDung) => {
        return this.SearchAllow(`(${idNoiDung})?$expand=thanhPhanThamDus($filter=khachMoiId ne null;$expand=khachMoi)&$select=id`)
    }
    addKhungThanhPhanThamDu = (data) => {
        return this.PostAuthen('/AddKhungThanhPhanThamDu', data)
    }
    ChuyenNoiDungHop = (data) => {
        return this.PostAuthen('/ChuyenNoiDungHop', data)
    }
    DeleteFileEmpty(fileId) { return this.DeleteAllow(`/XoaFileNoiDungEmpty?fileId=${fileId}`, { noLoading: true }) }
}
export default new KhungNoiDungsEndpoint();